import AXIOS from './axiosClient';


class WizardprofileService {

    saveProfile(profile) {
        return AXIOS.post("/profile", profile);
    }

    updateProfile(profile) {
        return AXIOS.put('/profile/' + profile.id, profile);
    }

    loadProfilesForField(fieldName) {
        return AXIOS.get('/profile/' + fieldName);
    }

    deleteProfile(profileId) {
        return AXIOS.delete('/profile/' + profileId);
    }

    publishProfile(profileId) {
        return AXIOS.put('/profile/' + profileId + '/publishProfile')
    }

    dePublishProfile(profileId) {
        return AXIOS.put('/profile/' + profileId + '/dePublishProfile')
    }

    setDefault(profileId) {
        return AXIOS.put('/profile/' + profileId + '/setDefault')
    }


}

export default new WizardprofileService();
